<template>
  <Breadcrumbs
      title="User Roles"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'User Roles', path: '/user-roles' },
    ]"
  />
  
  <div class="container-fluid">
    <div class="row project-cards">
      <userRoleList/>
    </div>
  </div>
</template>

<script>
import userRoleList from './userRoleList.vue';

export default {
  components: {
    userRoleList
  }
}
</script>